import * as type from './types'

export const mutations = {
  [type.SET_LOGGED_IN](state, bool) {
    state.user.loggedIn = bool
  },

  [type.SET_USER](state, firebaseResponse) {
    state.user.data = firebaseResponse || {}
  },

  [type.SET_USER_TOKEN](state, sessionConfig) {
    state.user.data = {
      ...state.user.data,
      ...sessionConfig,
    }
  },

  [type.SET_ORG](state, org) {
    state.org = org
  },
}